<template>
  <div class="role-filter">
    <div class="title">使用权限<i class="triangle-icon"></i></div>
    <div class="options">
      <div v-for="item, i in filterOptions" :key="i" class="option"
        :class="{selected: selectedValue === item.value}"
        @click="selectOption(item)"
      >
        {{item.text}}
      </div>
    </div>
  </div>
</template>
<script>
// import '../../../../../static/svg/'
import { mapGetters } from 'vuex';
import vipBadge from '@/components/mixins/vipBadge';

export default {
  mixins: [vipBadge],
  props: {
    initialValue: {
      type: String,
      default: 'all'
    }
  },
  data () {
    return {
      filterOptions: [
        {value: 'all', text: '全部'},
        {value: 'normal', text: '免费'},
        {value: 'person', text: '会员专属'},
        {value: 'enterprise', text: '企业会员专属'}
      ],
      selectedValue: 'all'
    }
  },
  computed: {
    ...mapGetters([
      'IsOldUser'
    ])
  },
  created () {
    this.selectedValue = this.initialValue;
    if (!this.IsOldUser) {
      this.filterOptions = [
        {value: 'all', text: '全部'},
        {value: 'normal', text: '免费'},
        {value: 'enterprise', text: this.getOptionName(6)},
        {value: 'person', text: this.getOptionName(4)}
      ]
    }
  },
  methods: {
    selectOption (item) {
      this.selectedValue = item.value;
      this.$emit('selectOption', item);
    }
  }
}
</script>
<style lang="scss" scoped>
.role-filter {
  position: relative;
  font-size: 12px;
  &:hover {
    .options {
      display: block;
    }
  }
  .options {
    position: absolute;
    display: none;
    top: 100%;
    right: 0;
    z-index: 1;
    border: 1px solid #D8DEE9;
    border-radius: 4px;
    background-color: #fff;
  }
}
.title {
  display: flex;
  align-items: center;
  padding: 5px;
}
.option {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 104px;
  height: 30px;
  padding-left: 14px;
  padding-right: 14px;
  opacity: 1;
  background-color: #fff;
  border-radius: 3px 3px 0px 0px;
  cursor: pointer;
  &.selected {
    background: #F5F7FA;
  }
}
.triangle-icon {
  display: inline-block;
  width: 10px;
  height: 6px;
  background: url('../../../../../static/svg/gray-triangle.svg') no-repeat center;
  margin-left: 6px;
  // &:hover {
  //   background: url('../../../../static/svg/inverted-triangle-active.svg') no-repeat center;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/smartVoice/roleFilter.vue